import classnames from 'classnames'
import Table from 'components/table_for_remark'
import { escape, isEmpty, trim } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import remark from 'remark'
import breaks from 'remark-breaks'
import remark2react from 'remark-react'
import { nl2br } from 'supports/text_format_react_helper'
import styles from './markdown.module.scss'

// descriptionのコードブロックをdivに置換してレンダリングする
const DESCRIPTION = 'language-description'
const Pre = ({ children }) => {
  const hasDescription = children.find(c => c.props.className === DESCRIPTION)

  if (!hasDescription) {
    return <pre>{children}</pre>
  }

  return children.map(node => {
    if (isEmpty(trim(node))) {
      return null
    }

    if (node.props.className === DESCRIPTION) {
      return (
        <div key={node.key} className={styles.description}>
          {nl2br(node.props.children[0])}
        </div>
      )
    }

    return null
  })
}

// remark の table だと "" でコンソールエラーになるのを防ぐ
const remarkReactComponents = {
  pre: Pre,
  table: Table,
  iframe: node => {
    const { value } = node.node

    // eslint-disable-next-line react/no-danger
    return <div className={styles.iframe} dangerouslySetInnerHTML={{ __html: value }} />
  },
  image: node => {
    const { value } = node.node

    // eslint-disable-next-line react/no-danger
    return <p dangerouslySetInnerHTML={{ __html: value }} />
  },
  string: node => escape(node.node.value)
}

const htmlHandler = (h, node) => {
  const props = { node }

  if (isEmpty(node)) {
    return null
  }

  const { value } = node

  if (value.match(/<img src="(.+?)/) || value.match(/<img srcset="(.+?)/)) {
    return h(node, 'image', props)
  }

  if (value.match(/<iframe (.+?)/)) {
    return h(node, 'iframe', props)
  }

  return h(node, 'string', props)
}

const Markdown = ({ className, content }) => {
  if (isEmpty(content)) {
    return null
  }

  return (
    <div className={classnames('markdown', className)}>
      {
        remark()
          .use(breaks)
          .use(remark2react, {
            sanitize: false,
            remarkReactComponents,
            toHast: {
              handlers: {
                html: htmlHandler
              }
            }
          })
          .processSync(content).contents
      }
    </div>
  )
}

Markdown.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string
}

Markdown.defaultProps = {
  className: null,
  content: null
}

export default Markdown
